/*
 * Pork Scratching Card (theme version of hydrogen app/components/bb/scratch/PorkScratchCard.tsx).
 * Data comes from sections/bb-scratch-card.liquid. Everyone wins: the card always
 * deals three pigs. State lives in the browser:
 *   sessionStorage bb_scratch_card       the dealt card {animals, revealed}
 *   sessionStorage bb_scratch_dismissed  closed this visit, don't reopen
 *   localStorage   bb_scratch_claimed    the code once claimed, never shown again
 *   sessionStorage bb_email              handed to the box builder's email box
 * Claiming: the code goes on the basket (/discount/CODE), the email and code on the basket's
 * attributes (_bb_email, _bb_scratch), and the email to Klaviyo when it's set up.
 * Shopify decides at checkout whether the code applies (once per customer).
 *
 * Leaflet visitors (docs/spec-leaflet-offer.md): a scan of a leaflet QR code (utm_medium=leaflet, in the address
 * or the bb_qr cookie the QR worker leaves) never gets the card. Their leaflet code goes on the basket instead,
 * and a welcome card says so. Each leaflet has its own code (Theme settings: leaflet|CODE); the card and builder
 * never show it, only checkout does, so it doesn't end up on voucher sites. Remembered for a week:
 *   localStorage   bb_leaflet            {campaign, at} of the scan
 *   localStorage   bb_leaflet_applied    the code put on the basket (the box builder reads it)
 *   sessionStorage bb_leaflet_shown      welcome card seen this visit
 */
(function () {
  'use strict';
  var el = document.querySelector('[data-bb-scratch-data]');
  if (!el) return;
  var D;
  try { D = JSON.parse(el.textContent); } catch (e) { return; }

  var OTHERS = ['chicken', 'cow', 'sheep'];
  var CARD = 'bb_scratch_card', DISMISSED = 'bb_scratch_dismissed', CLAIMED = 'bb_scratch_claimed', OFFER = 'bb_scratch_competing_offer';
  var OFFER_KINDS = ['referral', 'survey-voucher', 'eattelfit-review', 'doorknocking', 'whatsapp-offer'];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function get(store, key) { try { return window[store].getItem(key); } catch (e) { return null; } }
  function set(store, key, value) { try { window[store].setItem(key, value); } catch (e) { /* storage blocked */ } }
  function track(name, data) { if (window.bbTrack) window.bbTrack(name, data); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]; }); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  // A leaflet scan in the last week: from the address, the visit's saved tags (bb-track.js), or the QR cookie.
  var LEAFLET = 'bb_leaflet', LEAFLET_APPLIED = 'bb_leaflet_applied', LEAFLET_SHOWN = 'bb_leaflet_shown', WEEK = 7 * 864e5;
  function leafletVisit() {
    var L = D.leaflet;
    if (!L || !L.on) return null;
    var q = new URLSearchParams(location.search), tags = null;
    if (q.get('utm_medium')) tags = {utm_medium: q.get('utm_medium'), utm_campaign: q.get('utm_campaign')};
    if (!tags) { try { tags = JSON.parse(get('sessionStorage', 'bb_utm') || 'null'); } catch (e) {} }
    if (!tags) {
      var m = document.cookie.match(/(?:^|;\s*)bb_qr=([^;]*)/);
      try { tags = m ? JSON.parse(decodeURIComponent(m[1])) : null; } catch (e) {}
    }
    if (tags && tags.utm_medium === 'leaflet') set('localStorage', LEAFLET, JSON.stringify({campaign: String(tags.utm_campaign || '').slice(0, 40), at: Date.now()}));
    var seen = null;
    try { seen = JSON.parse(get('localStorage', LEAFLET) || 'null'); } catch (e) {}
    if (!seen || Date.now() - seen.at >= WEEK) return null;
    seen.code = (L.codes || {})[String(seen.campaign || '').toLowerCase()] || L.code;
    return seen.code ? seen : null;
  }
  var leaflet = leafletVisit();

  // Visitors who arrived through a different offer don't get the card (same rule as Hydrogen).
  function competingOffer() {
    var p = location.pathname, q = new URLSearchParams(location.search);
    var hit = (p === '/register' && (q.get('ref') || '').trim() !== '') || p === '/ff' || p.indexOf('/ff/') === 0 || p.indexOf('/claim/') === 0
      || OFFER_KINDS.indexOf((q.get('bb_offer') || '').toLowerCase()) >= 0;
    if (leaflet) hit = true;
    if (hit) set('sessionStorage', OFFER, '1');
    return hit || get('sessionStorage', OFFER) === '1';
  }

  function deal() {
    var cells = ['pig', 'pig', 'pig'];
    for (var n = 0; n < 3; n++) cells.push(OTHERS[Math.floor(Math.random() * OTHERS.length)]);
    for (var i = cells.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = cells[i]; cells[i] = cells[j]; cells[j] = t; }
    return cells;
  }
  function readCard() {
    try {
      var c = JSON.parse(get('sessionStorage', CARD) || 'null');
      if (c && c.animals && c.animals.length === 6 && c.animals.filter(function (a) { return a === 'pig'; }).length === 3) return c;
    } catch (e) {}
    return null;
  }

  var test = D.preview;
  var C = {stage: 'playing', animals: [], email: get('sessionStorage', 'bb_email') || '', error: '', busy: false, progress: 0};
  var root = null, canvases = [], last = [], prevFocus = null, hidden = [], lockY = 0, paintedW = 0, measuredAt = 0, pendingHref = null;

  function open(stage) {
    if (root) close(false);
    if (stage === 'leaflet') {
      C.stage = 'leaflet';
    } else if (test) {
      C.animals = deal();
      C.stage = stage || 'playing';
      C.progress = C.stage === 'playing' ? 0 : 1;
      C.error = '';
    } else {
      var card = readCard() || {animals: deal(), revealed: false};
      set('sessionStorage', CARD, JSON.stringify(card));
      C.animals = card.animals;
      C.stage = card.revealed ? 'won' : 'playing';
      C.progress = card.revealed ? 1 : 0;
    }
    prevFocus = document.activeElement;
    root = document.createElement('div');
    root.className = 'bb-scratch-backdrop';
    root.addEventListener('click', onClick);
    root.addEventListener('submit', onSubmit);
    root.addEventListener('input', function (e) { if (e.target.name === 'email') C.email = e.target.value; });
    // Hide the page from screen readers and keyboard while the card is open.
    hidden = Array.prototype.filter.call(document.body.children, function (n) { return n.tagName !== 'SCRIPT' && !n.inert; });
    hidden.forEach(function (n) { n.inert = true; });
    document.body.appendChild(root);
    lockScroll();
    C.started = false;
    if (!test) track(C.stage === 'leaflet' ? 'bb_leaflet_shown' : 'bb_scratch_shown', {stage: C.stage});
    document.addEventListener('keydown', onKey);
    render();
  }

  function close(remember) {
    if (!root) return;
    if (remember !== false && !test && C.stage !== 'leaflet') set('sessionStorage', DISMISSED, '1');
    window.removeEventListener('resize', repaintIfWider);
    document.removeEventListener('keydown', onKey);
    hidden.forEach(function (n) { n.inert = false; });
    hidden = [];
    root.remove();
    root = null;
    unlockScroll();
    if (prevFocus && prevFocus.focus) prevFocus.focus();
    if (pendingHref && remember !== false) { var go = pendingHref; pendingHref = null; location.href = go; }
  }

  // Freeze the page behind the card. iOS Safari ignores overflow:hidden on <body>, so the body is pinned
  // with position:fixed at the current scroll offset and put back exactly where it was on close.
  function lockScroll() {
    lockY = window.scrollY || window.pageYOffset || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = -lockY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
    document.documentElement.classList.add('bb-scratch-open');
    root.addEventListener('touchmove', guardTouch, {passive: false});
  }
  function unlockScroll() {
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    document.documentElement.classList.remove('bb-scratch-open');
    window.scrollTo({top: lockY, left: 0, behavior: 'instant'}); // instant: the theme may set smooth scrolling
  }
  // A swipe never moves anything behind the card. It may only scroll the card itself, and only when the
  // card is taller than the screen (a small phone with the keyboard up).
  function guardTouch(e) {
    var card = root && root.querySelector('.bb-scratch-card');
    if (C.stage === 'playing' && e.target.closest && e.target.closest('.bb-scratch-grid')) { e.preventDefault(); return; }
    if (!card || !card.contains(e.target) || card.scrollHeight <= card.clientHeight) e.preventDefault();
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab' || !root) return;
    var f = root.querySelectorAll('button:not([disabled]), input:not([disabled]), [href]');
    if (!f.length) return;
    var first = f[0], lastEl = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
  }

  function render() {
    var s = C.stage, copy = D.copy || {};
    var titleId = s === 'won' ? 'bb-scratch-win-title' : s === 'claimed' ? 'bb-scratch-claimed-title' : s === 'leaflet' ? 'bb-scratch-leaflet-title' : 'bb-scratch-title';
    var h = '<div class="bb-scratch-card bb-scratch-card--' + s + (C.justWon ? ' is-just-won' : '') + '" role="dialog" aria-modal="true" aria-labelledby="' + titleId + '" tabindex="-1">' +
      '<button type="button" class="bb-scratch-close" data-act="close" aria-label="' + (s === 'leaflet' ? 'Close' : 'Close scratch card') + '"><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg></button>' +
      (test ? '<p class="bb-scratch-test-label">Preview only, offer not active</p>' : '') +
      '<img src="' + esc(D.images.ben) + '" alt="" aria-hidden="true" draggable="false" class="bb-scratch-logo" width="300" height="266">' +
      '<p class="bb-scratch-kicker">' + esc(s === 'leaflet' ? 'From your leaflet' : copy.kicker || 'Pork Scratching Card') + '</p>';
    if (s === 'playing' || s === 'error') {
      h += '<h2 id="bb-scratch-title">' + esc(copy.title || 'Scratch & Win!') + '</h2><p class="bb-scratch-note">' + esc(copy.note || 'Match three porky pigs to win a prize!') + '</p>';
    }
    if (s === 'playing' || s === 'won') {
      h += '<div class="bb-scratch-grid" aria-label="' + (s === 'playing' ? 'Six scratch panels' : 'Animal prize panels') + '">' + C.animals.map(function (a, i) {
        var win = s === 'won' && a === 'pig';
        return '<div class="bb-scratch-panel' + (win ? ' bb-scratch-panel-winner' : '') + '">' +
          '<img src="' + esc(D.images[a]) + '" alt="' + cap(a) + ' silhouette" draggable="false" class="bb-scratch-animal' + (a === 'chicken' ? ' bb-scratch-animal--chicken' : '') + '">' +
          (win ? '<span class="bb-scratch-winner-badge">Winner</span>' : '') +
          (s === 'playing' ? '<canvas data-i="' + i + '" aria-label="Scratch panel ' + (i + 1) + '"></canvas>' : '') +
          '</div>';
      }).join('') + '</div>';
    }
    if (s === 'playing') {
      h += '<div class="bb-scratch-playing"><div class="bb-scratch-progress" role="progressbar" aria-label="Scratch card revealed" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(C.progress * 100) + '"><span style="transform:scaleX(' + C.progress + ')"></span></div>' +
        '<button type="button" class="bb-scratch-reveal" data-act="reveal">Reveal my prize</button>' +
        '<p>Scratch the panels, or use Reveal my prize to skip scratching.</p></div>';
    } else if (s === 'won') {
      h += '<form class="bb-scratch-win bb-scratch-claim-form" novalidate>' +
        '<p id="bb-scratch-win-title" class="bb-scratch-win-title" tabindex="-1">You&rsquo;ve won <span class="bb-scratch-discount">' + D.percent + '% off</span><br>your first box!</p>' +
        '<div class="bb-scratch-claim-row"><label class="bb-scratch-input-wrap"><svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.6" fill="none"/><path d="M3 7l9 6 9-6" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>' +
        '<input name="email" type="email" value="' + esc(C.email) + '" placeholder="Email address" aria-label="Email address" autocomplete="email" required></label>' +
        '<button type="submit" class="bb-scratch-primary"' + (C.busy ? ' disabled' : '') + '>' + (C.busy ? 'Claiming…' : 'Claim offer') + '</button></div>' +
        (C.error ? '<p class="bb-scratch-error" role="alert">' + esc(C.error) + '</p>' : '') +
        '<p class="bb-scratch-privacy">' + esc(copy.small || 'Your first box. One per customer.') + (test ? ' Preview only: no discount is applied.' : '') + '</p></form>';
    } else if (s === 'leaflet') {
      var L = D.leaflet || {};
      h += '<div class="bb-scratch-win bb-scratch-claimed"><p id="bb-scratch-leaflet-title" class="bb-scratch-win-title" tabindex="-1">Welcome! <span class="bb-scratch-discount">' + (L.percent || 20) + '% off</span><br>your first box</p>' +
        '<p class="bb-scratch-claimed-copy">' + (test ? 'This is a preview. No discount has been applied.' : 'It\u2019s already on your basket, so you\u2019ll see it at checkout. No code to type.') + '</p>' +
        (test ? '<button type="button" class="bb-scratch-primary" data-act="close">Close preview</button>' : '<div class="bb-scratch-actions"><a class="bb-scratch-primary" href="' + esc(D.builderUrl || '/pages/build-your-box') + '">Build my box</a><button type="button" class="bb-scratch-secondary" data-act="close">Browse the site</button></div>') +
        '<p class="bb-scratch-privacy">Your first box. One per customer.</p></div>';
    } else if (s === 'claimed') {
      h += '<div class="bb-scratch-win bb-scratch-claimed"><p id="bb-scratch-claimed-title" class="bb-scratch-win-title bb-scratch-claimed-title" tabindex="-1">' + (test ? 'Preview complete' : 'Offer claimed') + '</p>' +
        '<p class="bb-scratch-claimed-copy">' + (test ? 'This is a preview. No discount has been claimed or applied.' : 'Your ' + D.percent + '% off is on your basket. You\u2019ll see your ' + D.percent + '% off at checkout.') + '</p>' +
        (test ? '<button type="button" class="bb-scratch-primary" data-act="close">Close preview</button>' : '<div class="bb-scratch-actions"><a class="bb-scratch-primary" href="' + esc(discountUrl(D.builderUrl)) + '">Build my box</a><button type="button" class="bb-scratch-secondary" data-act="close">Browse the site</button></div>') + '</div>';
    } else {
      h += '<div class="bb-scratch-form"><p class="bb-scratch-error" role="alert">' + esc(C.error || 'Something went wrong.') + '</p><button type="button" class="bb-scratch-primary" data-act="retry">Try again</button></div>';
    }
    h += '</div>';
    root.innerHTML = h;
    canvases = [];
    if (s === 'playing') {
      root.querySelectorAll('canvas').forEach(function (cv) {
        canvases[+cv.getAttribute('data-i')] = cv;
        cv.addEventListener('pointerdown', scratch);
        cv.addEventListener('pointermove', scratch);
        cv.addEventListener('pointerup', function (e) { e.preventDefault(); last = []; if (root) measure(true); });
        cv.addEventListener('pointercancel', function () { last = []; });
        cv.addEventListener('pointerleave', function () { last[+cv.getAttribute('data-i')] = null; });
      });
      paintedW = 0;
      window.requestAnimationFrame(paint);
      window.addEventListener('resize', repaintIfWider);
    } else {
      window.removeEventListener('resize', repaintIfWider);
    }
    window.requestAnimationFrame(function () {
      if (!root) return;
      var target = s === 'won' ? (C.error ? root.querySelector('input[name=email]') : root.querySelector('#bb-scratch-win-title'))
        : s === 'claimed' ? root.querySelector('#bb-scratch-claimed-title') : s === 'leaflet' ? root.querySelector('#bb-scratch-leaflet-title') : root.querySelector('.bb-scratch-card');
      if (target) target.focus();
    });
  }

  function discountUrl(path) { return '/discount/' + encodeURIComponent(D.code) + '?redirect=' + encodeURIComponent(path || '/'); }

  // Silver coating, same look as Hydrogen.
  function paint() {
    last = [];
    paintedW = canvases[0] ? canvases[0].getBoundingClientRect().width : 0;
    canvases.forEach(function (cv) {
      if (!cv) return;
      var r = cv.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = Math.max(1, Math.round(r.width * dpr));
      cv.height = Math.max(1, Math.round(r.height * dpr));
      var x = cv.getContext('2d', {willReadFrequently: true});
      if (!x) return;
      x.scale(dpr, dpr);
      var g = x.createLinearGradient(0, 0, 0, r.height);
      g.addColorStop(0, '#666e71'); g.addColorStop(0.46, '#7d8588'); g.addColorStop(0.54, '#8a9294'); g.addColorStop(1, '#646c6f');
      x.fillStyle = g; x.fillRect(0, 0, r.width, r.height);
      var sh = x.createLinearGradient(0, 0, r.width, r.height);
      sh.addColorStop(0, 'rgba(255,255,255,0)'); sh.addColorStop(0.46, 'rgba(255,255,255,0)'); sh.addColorStop(0.5, 'rgba(255,255,255,0.3)'); sh.addColorStop(0.54, 'rgba(255,255,255,0)'); sh.addColorStop(1, 'rgba(255,255,255,0)');
      x.globalAlpha = 0.34; x.fillStyle = sh; x.fillRect(0, 0, r.width, r.height); x.globalAlpha = 1;
    });
  }

  // Phones fire resize when the toolbar or keyboard moves; only a real change of panel width (rotating the
  // phone) needs the coating redrawn, otherwise half-scratched panels would silently reset.
  function repaintIfWider() {
    var w = canvases[0] ? canvases[0].getBoundingClientRect().width : 0;
    if (Math.abs(w - paintedW) > 1) paint();
  }

  function coverage() {
    return canvases.map(function (cv) {
      if (!cv || !cv.width || !cv.height) return 0;
      var px = cv.getContext('2d').getImageData(0, 0, cv.width, cv.height).data;
      var step = Math.max(6, Math.round((window.devicePixelRatio || 1) * 5)), clear = 0, total = 0;
      for (var y = 0; y < cv.height; y += step) for (var x = 0; x < cv.width; x += step) { total++; if (px[(y * cv.width + x) * 4 + 3] < 64) clear++; }
      return total ? clear / total : 0;
    });
  }

  function scratch(e) {
    e.preventDefault();
    if (C.stage !== 'playing') return;
    if (e.type === 'pointerdown') e.currentTarget.setPointerCapture(e.pointerId);
    var hover = e.pointerType === 'mouse' && e.type === 'pointermove';
    if (e.buttons === 0 && e.type !== 'pointerdown' && !hover) return;
    // Pointer capture keeps one drag going across all six panels: erase whichever is under the pointer.
    var i = canvases.findIndex(function (cv) { var b = cv && cv.getBoundingClientRect(); return b && e.clientX >= b.left && e.clientX <= b.right && e.clientY >= b.top && e.clientY <= b.bottom; });
    var cv = canvases[i];
    if (!cv) return;
    var r = cv.getBoundingClientRect(), x = cv.getContext('2d'), px = e.clientX - r.left, py = e.clientY - r.top, prev = last[i];
    // Brush in proportion to the panel: about a quarter of its width, so a finger has to sweep each panel
    // (a fixed 45px brush wiped a whole phone panel in one tap).
    var radius = Math.max(22, r.width * 0.26);
    x.globalCompositeOperation = 'destination-out';
    x.beginPath(); x.lineCap = 'round'; x.lineJoin = 'round'; x.lineWidth = radius * 2;
    if (prev && prev.id === e.pointerId) { x.moveTo(prev.x, prev.y); x.lineTo(px, py); } else { x.moveTo(px, py); x.lineTo(px + 0.01, py); }
    x.stroke();
    last[i] = {id: e.pointerId, x: px, y: py};
    if (!C.started) { C.started = true; if (!test) track('bb_scratch_started', {pointer: e.pointerType}); }
    measure(false);
  }

  // Reading the six canvases is the slow part, so it runs at most every 100ms while scratching (and always
  // when the finger lifts). Revealed when every panel is half cleared, or the card is 80% cleared overall,
  // so a missed corner never leaves someone stuck.
  function measure(force) {
    var now = Date.now();
    if (!force && now - measuredAt < 100) return;
    measuredAt = now;
    var cov = coverage();
    if (cov.length !== 6) return;
    C.progress = cov.reduce(function (s, c) { return s + Math.min(1, c / 0.5); }, 0) / cov.length;
    var bar = root.querySelector('.bb-scratch-progress');
    if (bar) { bar.setAttribute('aria-valuenow', Math.round(C.progress * 100)); bar.firstChild.style.transform = 'scaleX(' + C.progress + ')'; }
    var avg = cov.reduce(function (s, c) { return s + c; }, 0) / 6;
    if (cov.every(function (c) { return c >= 0.5; }) || avg >= 0.8) reveal('scratched');
  }

  function reveal(how) {
    if (C.stage !== 'playing') return;
    if (!test) track('bb_scratch_revealed', {method: how || 'button'});
    if (!test) {
      var card = readCard();
      if (card) { card.revealed = true; set('sessionStorage', CARD, JSON.stringify(card)); }
    }
    C.progress = 1;
    C.stage = 'won';
    C.justWon = true;
    if (navigator.vibrate) { try { navigator.vibrate([18, 40, 18]); } catch (e) {} }
    render();
    C.justWon = false;
  }

  function onClick(e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    var act = b.getAttribute('data-act');
    if (act === 'close') close();
    else if (act === 'reveal') reveal('button');
    else if (act === 'retry') { C.error = ''; C.stage = 'playing'; render(); }
  }

  function onSubmit(e) {
    e.preventDefault();
    var email = String(C.email || '').trim().toLowerCase();
    if (!EMAIL_RE.test(email)) { C.error = 'Please enter a valid email address.'; render(); return; }
    C.email = email; C.error = '';
    if (test) { C.stage = 'claimed'; render(); return; }
    C.busy = true; render();
    // Hand the email to the box builder, unless the visitor already typed one there.
    if (!get('sessionStorage', 'bb_email')) set('sessionStorage', 'bb_email', email);
    if (!get('sessionStorage', 'bb_source')) set('sessionStorage', 'bb_source', 'scratch card');
    // Lead to Klaviyo when it's set up (Theme settings: public key + list), the same call as the builder.
    // Shopify's own newsletter form can't be sent from a script (it needs a CAPTCHA token).
    var K = D.klaviyo || {};
    var lead = K.key && K.list ? fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(K.key), {
      method: 'POST', headers: {'Content-Type': 'application/json', revision: '2024-10-15'},
      body: JSON.stringify({data: {type: 'subscription', attributes: {profile: {data: {type: 'profile', attributes: {email: email, properties: Object.assign({bb_source: 'scratch card'}, window.bbTrack && bbTrack.leadProps ? bbTrack.leadProps() : {})}}}, custom_source: 'Scratch card'}, relationships: {list: {data: {type: 'list', id: K.list}}}}})
    }).catch(function () {}) : null;
    // Put the code on the basket now (so it's there even if they browse first), THEN save the email and
    // code on the basket's attributes: run together, the discount link overwrites the attributes.
    var basket = fetch('/discount/' + encodeURIComponent(D.code) + '?redirect=%2Fcart.js', {credentials: 'same-origin'}).catch(function () {})
      .then(function () {
        return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, credentials: 'same-origin',
          body: JSON.stringify({attributes: {_bb_email: email, _bb_scratch: D.code}})});
      }).catch(function () {});
    Promise.all([lead, basket]).then(function () {
      set('localStorage', CLAIMED, D.code);
      set('sessionStorage', CLAIMED, D.code);
      track('bb_scratch_claimed', {percent: D.percent});
      C.busy = false; C.stage = 'claimed'; render();
    });
  }

  // Shopify's cookie banner and the card must never be on screen together (the card would cover it). Wait
  // until the banner has had time to appear and, if it did, until the visitor has answered it.
  function whenBannerAnswered(fn) {
    var t0 = Date.now();
    (function check() {
      var b = document.getElementById('shopify-pc__banner');
      var cs = b && getComputedStyle(b), box = b && b.getBoundingClientRect();
      // The banner is position:fixed, so offsetParent can't be used; check it takes up space and is visible.
      var showing = !!b && cs.display !== 'none' && cs.visibility !== 'hidden' && +cs.opacity > 0 && box.width > 0 && box.height > 0;
      if (showing || (!b && Date.now() - t0 < 800)) { window.setTimeout(check, showing ? 500 : 250); return; }
      fn();
    })();
  }

  // Leaflet visitor: the leaflet code replaces any code on the basket (codes don't combine, and it's the
  // better offer), once a visit. Then the welcome card, once a visit, where the scratch card could show.
  function startLeaflet() {
    var L = D.leaflet, code = leaflet.code, applied = get('sessionStorage', LEAFLET_APPLIED) === code ? Promise.resolve() :
      fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, credentials: 'same-origin',
        body: JSON.stringify({discount: code, attributes: {_bb_leaflet: leaflet.campaign || 'leaflet'}})})
        .then(function (r) {
          if (!r.ok) return;
          set('sessionStorage', LEAFLET_APPLIED, code);
          set('localStorage', LEAFLET_APPLIED, code);
          track('bb_leaflet_applied', {campaign: leaflet.campaign || '', percent: L.percent});
        }).catch(function () {});
    if (!L.card || get('sessionStorage', LEAFLET_SHOWN) === '1') return;
    applied.then(function () {
      whenBannerAnswered(function () { window.setTimeout(function () {
        if (root) return;
        set('sessionStorage', LEAFLET_SHOWN, '1');
        open('leaflet');
      }, D.delay || 0); });
    });
  }

  function start() {
    if (test) {
      document.querySelectorAll('[data-bb-scratch-stage]').forEach(function (b) {
        b.addEventListener('click', function () { open(b.getAttribute('data-bb-scratch-stage')); });
      });
      var q = new URLSearchParams(location.search).get('stage');
      open(['won', 'claimed', 'leaflet'].indexOf(q) >= 0 ? q : 'playing');
      return;
    }
    if (leaflet) { startLeaflet(); return; }
    if (!D.live || !D.code) return;
    if (competingOffer()) return;
    if (get('localStorage', CLAIMED) === D.code || get('sessionStorage', DISMISSED) === '1') return;
    // Nobody starts a box without seeing the card: a "Build my box" click before it has shown (say the
    // visitor skipped the cookie banner) opens the card first, and closing it carries on to the builder.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="build-your-box"]');
      if (!a || root || e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (get('localStorage', CLAIMED) === D.code || get('sessionStorage', DISMISSED) === '1') return;
      e.preventDefault();
      pendingHref = a.href;
      open();
    }, true);
    whenBannerAnswered(function () { window.setTimeout(function () { if (!root && !pendingHref && get('sessionStorage', DISMISSED) !== '1') open(); }, D.delay || 0); });
  }

  start();
})();
